import { Button, CircularProgress, Grid } from "@mui/material";
import { useBuyRequestsPassAllMutation, useGetDissaprobalReasonQuery, useBuyRequestsApproveAllMutation } from "../../../../../../services/swarmsApi";

import { addOrUpdateSwarm, selectSwarmSelected } from "../../../../../../store/slices/swarmsInAction";
import { useSelector } from "react-redux";
import { useNotification } from "../../../../../../context/NotificationContext";
import { createErrorMessage } from "../../../../../../utils";
import { ReasonMenu } from "../../../../../../components/reasonMenu";
import { useDispatch } from "react-redux";
import { useState } from "react";
import BasicModalConfirmation from "../../../../../../components/basicModalConfirmation";

function passAllOrApproveAllButtonIsDisabled(swarmSelected){
  if(!swarmSelected || swarmSelected.running == undefined || swarmSelected.running == null) return true;
  return swarmSelected.running || swarmSelected.isApproveAllActive;
}

export default function PassApproveAllButtons({hasPendingBuyRequest}) {
  const { data: disapprovalReasons, isLoading, error } = useGetDissaprobalReasonQuery();
  const swarmSelected= useSelector(selectSwarmSelected);
  const { showNotification } = useNotification();
  const [buyRequestPassAllTrigger, {isLoading: buyRequestPassAllIsLoading}] = useBuyRequestsPassAllMutation();
  const [buyRequestApproveAllTrigger, {isLoading: buyRequestApproveAllIsLoading}] = useBuyRequestsApproveAllMutation();
  const dispatch = useDispatch();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);


  async function handleBuyRequestPassAll(reasonId){
    try {
      console.log("passing all Buy Requests for swarmId: ", swarmSelected.id);
      await buyRequestPassAllTrigger({swarmId: swarmSelected.id, reasonId: reasonId}).unwrap();
      showNotification("All buy requests passed successfully", "success");
    } catch (error) {
      console.error("Error passing all buy requests:", error);
      showNotification(createErrorMessage(error), "error");
    }
  }

  async function handleBuyRequestApproveAll(){
    try {
      console.log("approving all Buy Requests for swarmId: ", swarmSelected.id);
      await buyRequestApproveAllTrigger({swarmId: swarmSelected.id}).unwrap();
      showNotification("All buy requests approved successfully", "success");
      //TODO: hasPendingBuyRequest is hardcoded to true, review in the future.
      dispatch(addOrUpdateSwarm({id: swarmSelected.id, isApproveAllActive: true, hasPendingBuyRequest: true})); 
    } catch (error) {
      console.error("Error approving all buy requests:", error);
      showNotification(createErrorMessage(error), "error");
    }
  }

  const openConfirmModal = () => {
    setConfirmModalOpen(true);
  };

  const closeConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const somethingIsLoading = buyRequestPassAllIsLoading || buyRequestApproveAllIsLoading;

  return (
    <Grid style={{ margin:'0 0 0.5em 0', display: 'flex', alignItems: 'center' }} >
      
      <ReasonMenu 
        reasons={disapprovalReasons} 
        onSelect={handleBuyRequestPassAll} 
        loading={buyRequestPassAllIsLoading}
        style={{ display: 'inline-flex' }}
        disabled={!hasPendingBuyRequest || passAllOrApproveAllButtonIsDisabled(swarmSelected) || somethingIsLoading}
      >
        <Button 
          disabled={!hasPendingBuyRequest || passAllOrApproveAllButtonIsDisabled(swarmSelected) || somethingIsLoading}
          color="error" 
          variant="contained" size="small" style={{ margin:'0 1em 0 0' }}
        >
          {
            buyRequestPassAllIsLoading ?
              <CircularProgress size={18} color="inherit" /> :
              "PASS ALL REQUESTS"
          }
        </Button>
      </ReasonMenu>
      <Button 
        disabled={ !hasPendingBuyRequest || passAllOrApproveAllButtonIsDisabled(swarmSelected) || somethingIsLoading}
        onClick={openConfirmModal} color="success" variant="contained" size="small" style={{ color: 'white' }} >
          {
            buyRequestApproveAllIsLoading ?
              <CircularProgress size={18} color="inherit" /> :
              "APPROVE ALL REQUESTS"
          }
      </Button>
      
      <BasicModalConfirmation
        open={confirmModalOpen}
        handleClose={closeConfirmModal}
        title="Are you sure you want to approve all requests?"
        confirmLabel="Yes"
        cancelLabel="Cancel"
        onClick={handleBuyRequestApproveAll}
      />
    </Grid>
  );
}